<!-- 不良申诉 添加/详情 sqm -->
<template>
  <ComponentAppeal :kindType="data.kindType" :getData="data.getData" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading" v-if="data.kindType == 'sqmAdd' || data.getData.badTypename"></ComponentAppeal>
    <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentAppeal from "../ComponentAppeal"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'',
    getData:{},
    subLoading:false,
    pageLoading:false,
    trueName:null,
    userName:null,
    sourceId:null,
    conformityDeclarationsId:null,
    supplyCode:null,
    supplyName:null,
    
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  const submit = (val) => {
    // 提交确认
      // 创建时需要生成唯一键******appealId
      if (val.badTypename == "现场不良") {
        val.appealId = "SS" + new Date().getTime();
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.badType = 1299;
        val.userId = data.supplyCode;
        val.appealStatusid = 2141;
        val.number = val.number;
      } else if(val.badTypename == "入厂不合格"){
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.badType = 2188;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
        val.badId = val.badId;
        val.sendGoodsNo = val.badId;
        val.badDescribe = val.flawMark;
        val.flawMark = val.flawMark;
        val.batchFailId = val.batchFailId;
        val.uuid = val.uuid;
        val.uuidFail = val.uuid;
        val.number = val.patternAmount;
        val.goodsSort =  val.goodsSort;  
        val.checkTime = val.checkTime;
      } else if (val.badTypename == "实验不合格") {
        val.badType = 2189;
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
        val.number = val.patternAmount;
        val.badId = val.badId;
        val.testNo = val.badId;
        val.badDescribe = val.flawMark;
        val.flawMark = val.flawMark;
        val.sybId = val.fromLeaderDepartId;
      }else if (val.badTypename == "停检单") {
        val.badType = 1302;
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
        val.number = val.patternAmount;
        val.badId = val.badId;
        val.stopCheckId = val.badId;
        val.badDescribe = val.stopReason;
        val.flawMark = val.stopReason;
      }else if (val.badTypename == "纠偏单") {
        val.badType = 1301;
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
      }else if (val.badTypename == "8D整改单") {
        val.badType = 1329;
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
      } else if (val.badTypename == "差异化供应商市场不良品") {
        val.badType = 2235;
        val.inputId = data.userName; // 用username
        val.inputName = data.trueName;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144;
      } else if(val.badTypename == "破坏性实验补料"){
        val.inputId = data.supplyCode;
        val.inputName = data.trueName;
        val.badType = 3411;
        val.userId = data.supplyCode;
        val.appealStatusid = 2144
      }
      // 去除 inputDate
      val.inputDate = undefined;
      data.subLoading = true;
      proxy.$http({
        url: "/base/RefusalAppeal/saveOrUpdate",
        method: "post",
        data: { ...val }
      }).then((res=>{
          if (res.data.code === '0') {
            proxy.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message:res.data.data || h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'),confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: (action) => {
              routerBack()
            }})
          } else {
            proxy.info(res.data.msg || h_i18n('be7e9fd1652d817f831cff03fc88765e'))
          }
    })).catch(err=>{
      proxy.warning(err)
    }).finally(()=>{
      data.subLoading = false
    })
  }

  const getInfo = (appealId,type) => {
    data.pageLoading = true
    if(!route.query.badTypename){
      return
    }
    proxy.$http({
        method: "get",
        url: `/base/RefusalAppeal/selectRejectsByKey?appealid=${appealId}`,
      }).then((res) => {
        data.getData = res.data.data;
      }).catch(err=>{
        
      }).finally(()=>{
        data.pageLoading = false
        type && (data.getData.type = type)
      })
    
  }
  const init = () => {
    data.pageLoading = true
    data.getData.eightdId = route.query.eightdId 
    data.getData.rectifyId = route.query.rectifyId
    data.pageLoading = false
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      // 不良申诉 申诉人用userName
      //不良申诉优化：入厂不合格、实验不合格、停检不合格、现场退次、不良申诉发起申诉时，申诉人获取供应商的 username（现获取的是truename）
      data.getData.trueName = (route.query.userName||route.query.trueName) ?  route.query.userName||route.query.trueName : ''
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = (route.query.userName||route.query.trueName) ?  (route.query.userName||route.query.trueName) : ''
      data.trueName = (route.query.userName||route.query.trueName) ?  (route.query.userName||route.query.trueName) : ''
     
      if(route.query.type){
        data.getData.type = route.query.type
      }
      if(route.query.kindType){
        data.kindType = route.query.kindType
      }else{
        data.kindType = 'sqmDetail'
      }
      if(data.kindType == 'sqmDetail'){
        getInfo(route.query.appealId,route.query.type)
      }
      if(route.query.comeFrom == '8D' || route.query.comeFrom == '纠偏'){
        init()
      }
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>